<template>
  <label
    :class="[
      'kw-checkbox',
      disabled ? 'is-disabled' : '',
    ]"
  >
    <input
      type="checkbox"
      :id="id"
      :name="name"
      :value="value"
      :checked="value"
      :disabled="disabled"
      :required="required"
      @change="handleChange"
    />
    <span class="kw-checkbox__controls">
      <Svgicon name="check" v-if="value"/>
    </span>
    <span class="kw-checkbox__text">
      <slot />
    </span>
  </label>
</template>

<script>
import Svgicon from './Svgicon.vue';

export default {
  name: 'KwCheckbox',
  components: {
    Svgicon,
  },
  props: {
    id: String,
    name: String,
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: Boolean,
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.checked);
      this.$emit('change', event.target.checked);
    },
  },
};
</script>

<style lang="scss">
.kw-checkbox {
  appearance: none;
  cursor: pointer;
  color: $base;
  display: inline-block;
  outline: none;
  padding-left: rem(36);
  @include clearfix;
  input {
    display: none;
  }
  &__controls {
    @include border-radius($border-radius-size, all);
    background-color: white;
    border: 1px solid $base-lighter;
    color: white;
    height: rem(20);
    line-height: rem(16);
    width: rem(20);
    vertical-align: middle;
    margin-left: rem(-36);
    margin-top: em(-2);
    float: left;
    position: relative;
    text-align: center;
    @include font-size(16);
  }
  input:checked + .kw-checkbox__controls {
    background-color: $success;
    border-color: $success;
  }
  input:checked:disabled + .kw-checkbox__controls {
    background-color: $success-light;
    border-color: $success-light;
  }
  &.is-disabled {
    cursor: default;
    color: $base-lighter;
    &.kw-checkbox__controls {
      border: $base-lightest;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/KwCheckbox.vue